import { createClient } from '@supabase/supabase-js'
import { env } from './env'

// Log all environment variables (except sensitive ones)
console.log('Environment variables loaded:', {
  VITE_API_URL: env.VITE_API_URL,
  VITE_SUPABASE_URL: env.VITE_SUPABASE_URL,
  // Don't log ANON_KEY
})

const supabaseUrl = env.VITE_SUPABASE_URL
const supabaseAnonKey = env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables:', {
    hasUrl: !!supabaseUrl,
    hasAnonKey: !!supabaseAnonKey
  })
  throw new Error('Missing Supabase environment variables')
}

// Ensure we're using the correct URL format
const normalizedSupabaseUrl = supabaseUrl.endsWith('/')
  ? supabaseUrl.slice(0, -1)  // Remove trailing slash if present
  : supabaseUrl

// Log the final Supabase configuration
console.log('Initializing Supabase client:', {
  url: normalizedSupabaseUrl,
  mode: import.meta.env.MODE,
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD
})

export const supabase = createClient(normalizedSupabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: 'incept5-auth', // Updated from linguard-auth to use a proper app name
    flowType: 'pkce'
  }
})
